{
	"errorPage.404.button": "Torna alla pagina iniziale",
	"errorPage.404.code": "Errore 404",
	"errorPage.404.description": "Siamo spiacenti, la pagina che stai cercando non esiste o è stata spostata.",
	"errorPage.404.title": "Pagina non trovata…",
	"errorPage.network.description": "Non è stato possibile caricare la pagina.\nControlla le impostazioni Internet e riprova.",
	"errorPage.network.title": "Si è verificato un errore…",
	"global.refreshButton": "Ricarica",
	"global.toast.error.message": "Si è verificato un errore, riprova.",
	"global.toast.error.title": "Errore"
}
